export const LOAD_REQUESTED = "STAGE_DROPDOWN/LOAD_REQUESTED";
export const LOAD_SUCCESS = "STAGE_DROPDOWN/LOAD_SUCCESS";
export const LOAD_FAIL = "STAGE_DROPDOWN/LOAD_FAIL";

export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadStageDropdown = data => ({ type: LOAD_REQUESTED, data });
export const successLoadStageDropdown = data => ({ type: LOAD_SUCCESS, data });
export const failLoadStageDropdown = data => ({ type: LOAD_FAIL, data });
